<style scoped lang="scss">
.dropdown {
  position: relative;
  display: inline-block;
}

#searchInput {
  box-sizing: border-box;
  background-position: 14px 12px;
  background-repeat: no-repeat;
  font-size: 16px;
  padding: 14px 20px 12px 45px;
  border: none;
  border-bottom: 1px solid #ddd;
}
#searchInput:focus {
  outline: 3px solid #ddd;
}

.dropdown-item {
  height: 60px;
}
.dropdown-item:hover {
  background-image: none;
  background-color: $primary;
}
a.image_container {
  height: 65px;
  display: inline-block;
  overflow: hidden;
}
a.image_container img {
  background-color: white;
  height: 100%;
}
</style>
<template>
  <div>
    <div
      class="dropdown"
      :class="{ show: show, dropdown: true, 'is-invalid': hasErrors }"
      ref="dropdown"
    >
      <button
        @click="show = !show"
        class="btn btn-primary dropdown-toggle"
        type="button"
        :disabled="disabled"
      >
        <a v-if="vmodel" class="image_container"
          ><img class="p-1" :src="imageUrl(vmodel)" /><a
            :href="profileUrl(vmodel)"
            class="text-white pl-2"
          >
            {{ vmodel[resourceProperty] }}
          </a></a
        >
        <a v-else> Wähle ein Profil... </a>
      </button>
      <div :id="id" class="dropdown-menu" :class="{ show: show }">
        <input
          type="text"
          placeholder="Search.."
          ref="searchInput"
          v-model="search"
          id="searchInput"
          @keyup="filterFunction()"
        />
        <a
          v-for="model in models"
          :key="model.id"
          @click="select(model)"
          class="dropdown-item p-0 m-0 align-items-center"
        >
          <a class=" image_container"
            ><img class="p-1" :src="imageUrl(model)" /><span class="pl-2">
              {{ model[resourceProperty] }}
            </span></a
          >
        </a>
      </div>
    </div>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>
<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";
export default {
  data() {
    return {
      vmodel: null,
      models: [],
      show: false,
      id: "profileDropdown",
      search: ""
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  async created() {
    if (this.value) {
      let filter = [
        {
          name: "where",
          attributes: {
            id: this.value
          }
        }
      ];
      const { data } = await this.$http.get(
        `/api/v1/${this.attribute.resource}`,
        {
          params: { filter: filter }
        }
      );
      this.models = [data];
      this.select(this.models[0]);
    }
  },
  props: ["attribute", "value", "disabled"],
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    resourceProperty() {
      return this.attribute.resourceProperty !== undefined
        ? this.attribute.resourceProperty
        : "name";
    },
    valueProperty() {
      return this.attribute.valueProperty !== undefined
        ? this.attribute.valueProperty
        : "id";
    }
  },
  methods: {
    imageUrl(model) {
      return model.primary_image
        ? `${model.primary_image.url}?width=45&height=45`
        : model.primaryImage.url;
    },

    async filterFunction() {
      if (this.search.length >= 3) {
        let filter = this.attribute.filter
          ? Object.assign([], this.attribute.filter)
          : [];
        filter.push({
          name: "whereLike",
          attributes: "name",
          value: this.search
        });
        let appends = this.attribute.appends ? this.attribute.appends : [];
        const { data } = await this.$http.get(
          `/api/v1/${this.attribute.resource}`,
          {
            params: { filter: filter, appends: appends }
          }
        );
        this.models = data;
        this.vmodel = this.value;
      }
    },
    select(model) {
      this.vmodel = model;
      this.$emit("input", this.vmodel[this.valueProperty]);
      this.show = false;
    },
    profileUrl(model) {
      return model.is_fake
        ? `/fake/kartei/${model.id}`
        : `/mitglieder/kartei/${model.id}`;
    }
  }
};
</script>
